/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-10-12 13:56:39
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-03-11 13:44:21
 * @FilePath     : /marketing-introduce-ssr/pages/_app.tsx
 * @Description  : 未添加文件描述
 */

import 'normalize.css';
import './global.scss';
import './icons.scss';
import 'antd-mobile/dist/antd-mobile.css';

import lazySizes from 'lazysizes';
import { AppContextType } from 'next/dist/shared/lib/utils';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useEffect } from 'react';

import { envName, isBrowser, isNodeServer, SENSORS_SERVER_URL } from '@/common/const';

// 懒加载配置
lazySizes.cfg.expand = 100;

// 创建 NoSSR 包装器
const NoSSRWrapper = dynamic(() => Promise.resolve(({ children }: any) => <>{children}</>), {
  ssr: false
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function App({ Component, pageProps }: any): JSX.Element {
  async function popoutModal() {
    const { userPopoutModal } = await import('@/utils/popout');
    userPopoutModal();
  }
  async function initSensors() {
    const sensors = (await import('@woulsl-tools/sensors')).default;
    window.sensors = sensors;
    // utils.ts
    function getPlatform() {
      const ua = window.navigator.userAgent;
      let platform = '其他';
      const isWx = /MicroMessenger/i.test(ua);
      const isMiniApp = /miniprogram/i.test(ua);
      if (isWx && isMiniApp) {
        platform = '微信小程序';
      } else if (isWx) {
        platform = '微信内';
      } else if (/JoJoVersion/i.test(ua)) {
        platform = 'APP内';
      }
      return platform;
    }

    const sensorsMap: Record<string, string> = {
      fat: 'https://sensors.tinman.cn/sa?project=default',
      uat: 'https://sensors.tinman.cn/sa?project=default',
      dev: 'https://sensors.tinman.cn/sa?project=default',
      pro: SENSORS_SERVER_URL
    };

    const ssl: string | undefined =
      sensorsMap[envName || ''] || 'https://sensors.tinman.cn/sa?project=production';

    // main.ts 入口文件神策初始化配置，参数类型参考下方TinmanSensorConfigType
    const config = {
      lob: 'marketing',
      env_name: envName || 'dev',
      show_log: false,
      server_url: ssl,
      autoTrackSet() {
        sensors.quick('isReady', function () {
          // 注册公共属性
          sensors.registerPage({
            custom_platform: getPlatform()
          });
        });
        return false;
      }
    };

    // 入口文件初始化, 注册sensors
    sensors.tinmanSensorsInit(config);
  }
  useEffect(() => {
    if (isBrowser) {
      popoutModal();
      initSensors();
    }
  }, []);
  return (
    <>
      <Head>
        <meta
          name='viewport'
          content='width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover'
        />
        <link
          rel='icon'
          type='image/x-icon'
          href='https://design.tinman.cn/library/public/0.4.7/favicon.2024122571236.ico'
        />
        <title>叫叫</title>
        <meta
          name='viewport'
          content='width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1,minimum-scale=1,viewport-fit=cover'
        />
        <script
          defer
          src='https://design.tinman.cn/library/jojo-account-sdk/1.0.6/jojo-account-sdk-1.0.6.min.20246373725.js'
        />
        {envName !== 'pro' ? (
          <script src='https://design.tinman.cn/library/vconsole/3.12.1/vconsole.min.2022310152949.js' />
        ) : null}

        {envName !== 'pro' ? (
          <script
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: `new VConsole()`
            }}
          />
        ) : null}

        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `
  #accountSDKPopupIframe {
    position: fixed !important;
    z-index: 100
  }
  `
          }}
        />
        <script
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `
            try {
              window.onShareSuccess = function () { };
              window.pauseAllAudio = function () { };
              window.pauseYuwenAudio = function () { };
              
              // 全局状态保存
              var __store = {};

              // 兼容微信公告
              var search = window.location.search;
              if (search.indexOf('enPrm=') < 0 && search.indexOf('&amp;') >= 0) {
                window.location.replace(
                  search.replace(/&amp;/mg, '&')
                )
              };
            } catch (e) {
              console.error(e)
            }
            `
          }}
        />

        <script
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `
            if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
              handleFontSize();
            } else {
              if (document.addEventListener) {
                document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", handleFontSize);
                document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
              }
            }
            function handleFontSize() {
              // 设置网页字体为默认大小
              WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0});
              // 重写设置网页字体大小的事件
              WeixinJSBridge.on('menu:setfont', function () {
                  WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0});
              });
            }
            `
          }}
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `
            window.tenant = '${pageProps?.tenant || ''}';
            `
          }}
        />
      </Head>
      <NoSSRWrapper>
        <Component {...pageProps} />
      </NoSSRWrapper>
    </>
  );
}

if (isNodeServer) {
  App.getInitialProps = async (appContext: AppContextType) => {
    const { req } = appContext?.ctx || {};
    const tenant = req?.headers?.['x-jojo-tenant-id'] || '';
    return { pageProps: { tenant } };
  };
}

export default App;
